<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="this.$store.getters.language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="多语言lable" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['langCode', validatorRules.langCode]" :trigger-change="true" dictCode="" placeholder="请选择多语言lable"/>
        </a-form-item>
        <a-form-item label="多语言key" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'langKey', validatorRules.langKey]" placeholder="请输入多语言key"></a-input>
        </a-form-item>
        <a-form-item label="多语言value" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['langTrans', validatorRules.langTrans]" rows="4" placeholder="请输入多语言value"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { get, pick } from 'lodash';
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "TSysLanguageModal",
    components: {
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          langCode: {rules: [
            {required: true, message: '请输入多语言lable!'},
          ]},
          langKey: {rules: [
            {required: true, message: '请输入多语言key!'},
          ]},
          langTrans: {rules: [
          ]},
        },
        url: {
          add: "/sys/tSysLanguage/add",
          edit: "/sys/tSysLanguage/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'langCode','langKey','langTrans'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'langCode','langKey','langTrans'))
      },


    }
  }
</script>